module.exports = "/assets/cf9d2c75eb4adfab8af0260015f27e7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/3D.png
// module id = 1004
// module chunks = 0